export default "__VITE_ASSET__DADi0xm4__"